import React, { useEffect } from 'react'
// Components
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/contact.css'

export default function () {
  
  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);
  
  return (
    <div className='contact_page page_body'>
      <PageTransition />
      <div className='container'>
        <div className='page_title select_n'>Contact Us</div>
        <div className='page_content'>
          <div className='wrapper'>
            <div className='left'>
              <p>Contact us for any information or query. We are commited to reply.</p>
              <div className='contact_info'>
                <div className='icon select_n'>
                  <img src={require('../assets/icons/email.png')} alt='Email' />
                </div>
                <div className='info'>
                  <div className='title select_n'>Send us email on:</div>
                  <a href='mailto:codohov@gmail.com'>codohov@gmail.com</a>
                </div>
              </div>
              <div className='contact_info'>
                <div className='icon select_n'>
                  <img src={require('../assets/icons/call.png')} alt='Call' />
                </div>
                <div className='info'>
                  <div className='title select_n'>Call us on:</div>
                  <a href='tel:+8801724904320'>+880 1724-904320</a>
                </div>
              </div>
              <div className='contact_info'>
                <div className='icon select_n'>
                  <img src={require('../assets/icons/whatsapp.png')} alt='Whatsapp' />
                </div>
                <div className='info'>
                  <div className='title select_n'>Conact us on WhatsApp:</div>
                  <a target='_blank' href='https://wa.me/+8801724904320'>+880 1724-904320 <i className='fas fa-external-link-alt'></i></a>
                </div>
              </div>
              <div className='contact_info'>
                <div className='icon select_n'>
                  <img src={require('../assets/icons/messenger.png')} alt='Whatsapp' />
                </div>
                <div className='info'>
                  <div className='title select_n'>Conact us on Messenger:</div>
                  <a target='_blank' href='https://m.facebook.com/messages/thread/100622105277352/'>Send Message <i className='fas fa-external-link-alt'></i></a>
                </div>
              </div>
            </div>
            <div className='right'>
              <form className='contact_form form_primary'>
                <div className='header'>
                  <div className='form_title'>Send a message to us.</div>
                </div>
                <div className='inputs'>
                  <div className='input_container'>
                    <label className='form_label' htmlFor='name'>Name</label>
                    <input className='form_input' type='text' id='name' placeholder='Name' name='name' required />
                  </div>
                  <div className='input_container'>
                    <label className='form_label' htmlFor='email'>Email</label>
                    <input className='form_input' type='email' id='email' placeholder='Email' name='email' required />
                  </div>
                  <div className='input_container'>
                    <label className='form_label' htmlFor='message'>Message</label>
                    <textarea className='form_input form_textarea' id='message' name='message' required></textarea>
                  </div>
                </div>
                <div className='actions'>
                  <button className='btn btn_primary btn_hover bg-2' type='submit'>Send</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
